// SEQ-218: clearing a claim's payment data un-pays the hire rows it froze. A
// row that was re-claimed onto a LATER claim is still named in this claim's
// frozen list, but it now belongs to the later claim, so this claim must not
// touch it. Only rows attached to this report, or to none, are un-paid.

interface SupabaseLikeClient {
  // Matches the supabase-js query-builder surface this module uses; typed
  // loosely so tests can drive it with an in-memory fake.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  from(table: string): any;
}

export async function unpayHireRowsOfReport(
  client: SupabaseLikeClient,
  reportId: string,
  hireBillingIds: readonly string[],
): Promise<void> {
  if (hireBillingIds.length === 0) return;
  // reportId goes into a PostgREST filter string, so it must be a bare uuid.
  if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(reportId)) {
    throw new Error("Invalid report id");
  }
  const result = await client
    .from("claims_hire_billing")
    .update({
      paid: false,
      paid_amount: 0,
      billing_status: "included",
    })
    .in("id", hireBillingIds as string[])
    .or(`claim_report_id.is.null,claim_report_id.eq.${reportId}`);
  // A failed un-pay must surface: the caller reports success: false instead of
  // telling the user their payment data was cleared while rows stayed paid.
  if (result?.error) throw result.error;
}
